import { PeerConnection } from "@/utils/peer"
import CullerWorkerUrl from "./culler.worker.ts?worker&url"
import type { CullerWorker } from "./culler.worker"
import { MetadataLoaderConnection } from "../metadata/metadata-loader-connection"

export const CULLER_WORKER_COUNT = 1
export const CULLER_BATCH_SIZE = 5

export const CullerConnections = Array.from(
	{ length: CULLER_WORKER_COUNT },
	(_, index) =>
		new PeerConnection<CullerWorker>(CullerWorkerUrl, {
			label: `Culler ${index + 1}`,
			dependencies: {
				"metadata-loader": MetadataLoaderConnection,
			},
		}),
)

const primaryConnection = CullerConnections[0]
if (!primaryConnection) throw new Error("Culler worker pool is empty")
export const CullerConnection = primaryConnection
